// src/features.js
// ─────────────────────────────────────────────────────────────
// Switches Reece turns on and off in Settings that follow him to every
// device. Kept in settings.rate_sheets._features: rate_sheets is already a
// jsonb column (no migration), and an underscore key is bookkeeping nothing
// pricing-related reads — the rate-sheet editors (Settings, the calculator's
// sheet list), Today's Market (Calc setMarketRate / Settings
// applyMarketRate) and the calculator itself all skip underscore keys, the
// same as _swapHistory and _staffPrefs. The settings save merges it field by
// field (App mergeRateSheets3 → merge3 depth 1), so a flip on one device
// never wipes a sheet edited on another, and mergeRs keeps it on load.
//
// ownershipUi — "Lead assignment & Max on files". Reece, 10/10/26: "let's go
// ahead and deactivate the whole lead assignment and having Max show up on
// there … Leave it off. Have the option to toggle back on". OFF by default
// (only a literal true is on).
//   Off: Reece's screens show no owner chips, no "Whose files" switch, no
//   reassign / owner menus, no "(unassigned)" — and every file shows, as if
//   "All" were picked (Pipeline, Fallout, Re-price Radar, Command Center).
//   His numbers count every file and lead too: Expenses' income side and
//   Cost per letter stop splitting by owner (an owner he can't see never
//   takes a funded file or a letter out of his totals).
//   The DATA is untouched: owners are still stamped on new and worked leads
//   and files, nothing is rewritten or deleted, and the remembered "Whose
//   files" pick stays in this browser — so turning it back on brings every
//   bit of it back exactly as it was.
//   Max's own login never reads it: App hands his screens `true`, so they
//   stay exactly as they were.
// ─────────────────────────────────────────────────────────────
import { createContext, useContext } from 'react';

export const FEATURES_KEY = "_features";

function featuresOf(rateSheets) {
  const f = rateSheets && rateSheets[FEATURES_KEY];
  return (f && typeof f === "object" && !Array.isArray(f)) ? f : {};
}

// ownershipUiOn(settings) → boolean, from App's settings object
// ({rateSheets: {..., _features: {ownershipUi}}}).
export function ownershipUiOn(settings) {
  return featuresOf(settings && settings.rateSheets).ownershipUi === true;
}

// The rate sheets with the switch set: a new object where only
// _features.ownershipUi changed (other feature keys and every sheet are the
// same objects). Already set that way → the very same object back, so a
// no-op click never dirties the settings save.
export function withOwnershipUi(rateSheets, on) {
  const rs = rateSheets || {};
  const cur = featuresOf(rs);
  if ((cur.ownershipUi === true) === (on === true)) return rs;
  return Object.assign({}, rs, { [FEATURES_KEY]: Object.assign({}, cur, { ownershipUi: on === true }) });
}

// The switch as App decided it for the signed-in person (Reece: the setting;
// Max: always true — his screens are never changed by it). Default false, the
// same as the setting's default; a test that exercises the owner UI wraps what
// it renders in <OwnershipUiProvider value={true}>.
const OwnershipUiContext = createContext(false);
export const OwnershipUiProvider = OwnershipUiContext.Provider;
export function useOwnershipUi() {
  return useContext(OwnershipUiContext) === true;
}
